import axios from "axios";
import Config from "@/config"

export function fetchAchievements(accesstoken) {
    const options = {
        headers: {
            ...Config.headers(accesstoken), ...{},
        },
        params: {
            "pagination[pageSize]": 10000,
            populate: '*'
        },
    };
    return axios
        .get(
            Config.proxy + Config.url("achievements"),
            options
        )
        .then(res => res.data.data)
        .catch(
            function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
            }
        )
}
